import { configureStore } from '@reduxjs/toolkit';
import profileReducer from './slices/profileSlices';
import spinnerReducer from './slices/spinnerSlices';
import accountsReducer from './slices/accountsSlice';
import notificationReducer from './slices/notificationSlice';

export const store = configureStore({
  reducer: {
    user: profileReducer,
    spinner: spinnerReducer,
    accounts: accountsReducer,
    notification: notificationReducer,
  }
})

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
